import React from 'react';

const ReadingTip = () => {
    return (
        <div className="reading-tip">
            Read
            {' '}
            <b>out loud.</b>
        </div>
    );
};

export default ReadingTip;
